import * as React from 'react';
import { Table } from 'semantic-ui-react';
import { WrongCoordinatesShape } from '../../../types/anomaliesTypes';
import { TableSortProperties } from '../../../types/types';
import WrongCoordinatesShapesTableRow from './WrongCoordinatesShapesTableRow';


const styles = {
    table: {
        display: 'block',
        maxHeight: '385px',
        overflowY: 'scroll',
    } as React.CSSProperties,
};

interface Props {
    tableDataState: TableSortProperties<WrongCoordinatesShape>;
    rows: WrongCoordinatesShape[],
    selectedShapeId: string | undefined,
    selectedRowHandler: (selectedShapeId: string) => void;
    columnSortHandler: (column: string) => void;
}

const WrongCoordinatesShapesTable: React.FC<Props> = ({ tableDataState, selectedShapeId, selectedRowHandler, columnSortHandler }) => {

    const { column, data, direction } = tableDataState;
    return (
        <div>
            <Table celled striped compact singleLine fixed sortable style={styles.table} className="semanticTable">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'routeId' ? direction : undefined}
                            onClick={() => columnSortHandler('routeId')}>
                            Route
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'id' ? direction : undefined}
                            onClick={() => columnSortHandler('id')}>
                            Shape ID
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'onShape' ? direction : undefined}
                            onClick={() => columnSortHandler('onShape')}>
                            Trips Fully on Shape
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'outShape' ? direction : undefined}
                            onClick={() => columnSortHandler('outShape')}>
                            Trips not on Shape
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'outShapePcnt' ? direction : undefined}
                            onClick={() => columnSortHandler('outShapePcnt')}>
                            Trips not on Shape, %
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'onShapeTrips' ? direction : undefined}
                            onClick={() => columnSortHandler('onShapeTrips')}>
                            Positions on Shape
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'outShapeTrips' ? direction : undefined}
                            onClick={() => columnSortHandler('outShapeTrips')}>
                            Positions outside Shape
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="left" width={1} sorted={column === 'outShapePcntTrips' ? direction : undefined}
                            onClick={() => columnSortHandler('outShapePcntTrips')}>
                            Wrong Position, %
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {data.map((row, index) => (
                        <WrongCoordinatesShapesTableRow key={index} row={row} selectedShapeId={selectedShapeId} selectedRowHandler={selectedRowHandler} />
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

export default WrongCoordinatesShapesTable;